// extracted by mini-css-extract-plugin
export default {"line":"BgLine12--line--spXSh"};